<template lang="pug">
	section#conteudo
		.wrapper
			h2 Preencha o formulário abaixo para visualizar as informações
			div.aviso
				p
					| ATENÇÃO: Em razão das medidas preventivas adotadas contra COVID19, por
					| determinação dos órgãos oficiais, todos os processos dependentes de
					| atividades presenciais dos profissionais da UniFAEL e das instituições
					| certificadoras, sofreram alteração quanto aos prazos de emissão. Entre esses
					| processos, estão a expedição e registro de diplomas, conforme prevê a
					| Portaria 1095/2018 do Ministério da Educação.
					br
					br
					| As regras de distanciamento e isolamento social obrigatórias, em prevenção à
					| Pandemia, promoveram efeitos que afetam a todas as instituições de ensino,
					| assim como em outras atividades econômicas em todos os países do mundo.
					| Estamos empenhados em atenuar estes efeitos, buscando processos
					| alternativos com o objetivo de diminuir os prazos de emissão destes documentos.
					br
					br
					| Você pode solicitar
					| gratuitamente através do seu Portal de Aluno a CERTIDÃO DE CONCLUSÃO DE CURSO com emissão imediata.
					| Ressaltamos que a Certidão supre todos os efeitos legais imediatos do diploma.
			form#formulario(v-on:submit.prevent="validarDiploma()")
				div.group
					div.input._50
						input(name="nome", type="text", placeholder="Nome Completo", v-model="form.nome")
					div.input._50.required
						input(name="cpf", type="tel", placeholder="6 digitos centrais do CPF", v-model="form.cpf", v-mask="'######'")
						details
							summary Ajuda
							div.ajuda
								p O número a ser inserido deve ser correspondente aos 6 digitos seguintes aos 3 primeiros.
								p Em um dado CPF #[strong 123.456.789-01], o valor correspondente a ser inserido é #[strong 456789].

				div.botao
					button(type="submit") Enviar

			div.mensagem(v-if="avaliacaoDiploma.mensagem")
				p {{ avaliacaoDiploma.mensagem }}

			div.resultado(v-for="registro in avaliacaoDiploma.registros")
				div.table-head
				p {{ registro.nome_curso }}
				table
					tbody
						tr
							th Login
							td {{ registro.login }}
						tr
							th Nome completo do aluno
							td {{ registro.nome }}
						tr
							th Seis digitos centrais do CPF
							td {{ registro.cpf_reduzido }}
						tr
							th Nome do curso
							td {{ registro.nome_curso }}
						tr
							th Código do curso - EMEC
							td {{ registro.codigo_curso_emec }}
						tr
							th Nome da instituição
							td {{ registro.nome_fael }}
						tr
							th Código da instituição - EMEC
							td {{ registro.codigo_fael_emec }}
						tr
							th Nome da instituição registradora
							td {{ registro.nome_registradora }}
						tr
							th Código da instituição registradora - EMEC
							td {{ registro.codigo_registradora_emec }}
						tr
							th Data de ingresso no curso
							td {{ registro.data_ingresso_curso }}
						tr
							th Data de conclusão do curso
							td {{ registro.data_conclusao_curso }}
						tr
							th Data de expedição do diploma
							td {{ registro.data_expedicao_diploma }}
						tr
							th Data de registro do diploma
							td {{ registro.data_registro_diploma }}
						tr
							th Identificador do número da expedição
							td {{ registro.ident_numero_expedicao }}
						tr
							th Identificador do número do registro
							td {{ registro.ident_numero_registro }}
						tr
							th Publicação em DOU
							td {{ registro.publicacao_dou }}
</template>

<script>
	import qs from 'qs'
	import {mask} from 'vue-the-mask'

	export default {
		name: "section-conteudo",
		directives: {
			mask
		},
		data() {
			return {
				form: {
					nome: null,
					cpf: null,
				},
				avaliacaoDiploma: {
					registros: [],
					mensagem: ''
				}
			}
		},
		methods: {
			validarDiploma() {
				console.log('teste');
				this.avaliacaoDiploma.mensagem = "";
				this.avaliacaoDiploma.registro = null;
				if (this.form.cpf) {
					this.$axios
					.get(`/alunos-diplomas/get?${qs.stringify(this.form)}`)
					.then(response => {
						this.avaliacaoDiploma.registros = response.data.registros;
					}).catch(error => {
						this.avaliacaoDiploma.mensagem = error.response.data.msg;
					});
				} else {
					this.avaliacaoDiploma.mensagem = "O cpf é obrigatório"
				}
			},
		},
	}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>
